const cssAddress1Reducer = (state = '', action) => {
	switch(action.type){
	case 'CSSADDRESS1VALUE':
		return action.payload;
	default:
		return state;
	}
}

export default cssAddress1Reducer;